import { checkGet, checkPost } from './checkClient';

export type DealStepStatus = 'pending' | 'in_progress' | 'completed';
export type DealStatus = 'active' | 'completed' | 'cancelled';

export interface MarketDealStep {
  id: string;
  deal_id: string;
  step_key: string;
  title: string;
  owner_role: 'buyer' | 'seller' | 'platform' | 'shared';
  status: DealStepStatus;
  sort_order: number;
  note?: string;
  updated_by?: string;
  completed_at?: string;
  updated_at?: string;
  required_roles?: DealPartyRole[];
  confirmations?: MarketDealConfirmation[];
  confirmed_by?: Partial<Record<DealPartyRole, boolean>>;
  missing_roles?: DealPartyRole[];
}

export type DealPartyRole = 'buyer' | 'seller' | 'platform';

export interface MarketDealConfirmation {
  deal_id: string;
  step_key: string;
  confirmer_role: DealPartyRole;
  user_id?: string;
  note?: string;
  confirmed_at: string;
}

export interface MarketDeal {
  id: string;
  listing_id: string;
  plant_id: string;
  buyer_user_id: string;
  seller_user_id?: string;
  status: DealStatus;
  current_step_key: string;
  created_at: string;
  updated_at: string;
  completed_at?: string;
  current_user_deal_role?: DealPartyRole;
  can_confirm_current_step?: boolean;
  plant?: {
    id: string;
    name: string;
    capacity_kwp?: number;
    rating?: string;
    cpn_score?: number;
    status?: string;
  };
  listing?: {
    id: string;
    status: string;
  };
  steps?: MarketDealStep[];
}

export async function startDeal(plantId: string): Promise<MarketDeal> {
  return checkPost<MarketDeal>(`/marketplace/listings/${plantId}/deals`, {});
}

export async function getDeal(dealId: string): Promise<MarketDeal> {
  return checkGet<MarketDeal>(`/deals/${dealId}`);
}

export async function listDeals(): Promise<{ deals: MarketDeal[] }> {
  return checkGet<{ deals: MarketDeal[] }>('/deals');
}

export async function completeDealStep(dealId: string, stepKey: string, note?: string): Promise<MarketDeal> {
  return checkPost<MarketDeal>(`/deals/${dealId}/steps/${stepKey}/complete`, { note });
}
